import { render } from "./CharStartHead.vue?vue&type=template&id=021fd899&scoped=true&ts=true"
import script from "./CharStartHead.vue?vue&type=script&lang=ts"
export * from "./CharStartHead.vue?vue&type=script&lang=ts"

import "./CharStartHead.vue?vue&type=style&index=0&id=021fd899&scoped=true&lang=scss"

import exportComponent from "/Users/macbook/Documents/work_code/global/events_gevents.37games.com/src/resource/guidetro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-021fd899"]])

export default __exports__